import { Injectable } from '@angular/core';
import { EntityState, EntityStore } from '@examdojo/state';
import { StudentClassProps, StudentClassStoreModel } from './student-class.model';

export type StudentClassState = EntityState<StudentClassStoreModel, StudentClassProps>;

@Injectable({ providedIn: 'root' })
export class StudentClassStore extends EntityStore<StudentClassState, StudentClassStoreModel, 'id'> {
  constructor() {
    super({
      name: 'student-classes',
      idKey: 'id',
      initialPropsState: { initialized: false },
    });
  }
}
